module.exports = __webpack_public_path__ + "media/MRI2.4085baa3.mp3";